import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import FormFieldInputUniDriver from '../FormFieldInput/FormFieldInput.uni.driver';

export default (base: UniDriver, body: UniDriver) => {
  return {
    field: (id: string) =>
      FormFieldInputUniDriver(base.$(`[data-hook="field-${id}"]`), body),
    ...baseUniDriverFactory(base),
  };
};
